import React from 'react';
import { Link } from 'react-router-dom';
import { Layers3, RefreshCw } from 'lucide-react';
import { PRODUCT_CATALOG } from './productCatalog';
import { productScopeQuery } from './productMetrics';
import './Products.css';

export default function ProductFrame({ product, locale, environment, range, preset, filters, onRefresh, fetching, children }) {
  const ko = locale === 'ko';
  const copy = (a, b) => ko ? a : b;
  return <>
    <div className="product-topline"><span><Layers3 size={15} />{copy('제품별 현황', 'Product overview')}</span><span className="product-environment">{environment} · {copy('읽기 전용', 'Read only')}</span></div>
    <nav className="product-switcher" aria-label={copy('제품 선택', 'Choose product')}>
      {PRODUCT_CATALOG.map(item => <Link key={item.id} to={`/products/${item.id}?${item.source === 'contentUsage' ? `range=${preset === '30d' ? '30d' : '7d'}` : productScopeQuery(range, preset, filters)}`} aria-current={product.id === item.id ? 'page' : undefined}>{ko ? item.nameKo || item.name : item.name}{product.id === item.id && <span className="product-nav-dot" />}</Link>)}
    </nav>
    <header className="product-hero">
      <div><p className="product-eyebrow">{product[ko ? 'eyebrowKo' : 'eyebrowEn']}</p><h1>{ko ? product.nameKo || product.name : product.name}</h1><h2>{product[ko ? 'questionKo' : 'questionEn']}</h2><p>{product[ko ? 'descriptionKo' : 'descriptionEn']}</p></div>
      <button className="product-button" onClick={onRefresh} disabled={fetching || !onRefresh}><RefreshCw size={16} />{copy('새로고침', 'Refresh')}</button>
    </header>
    {children}
  </>;
}
